import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#a)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.281 9.187 8.094 12l-2.813 2.813M1 11.999h6m11.719 2.814L15.906 12l2.813-2.813M23 12.001h-6M12.094 1v22",
				stroke: "#262626",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h24v24H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cg%20clip-path%3D%22url(%23a)%22%3E%3Cpath%20d%3D%22M5.281%209.187%208.094%2012l-2.813%202.813M1%2011.999h6m11.719%202.814L15.906%2012l2.813-2.813M23%2012.001h-6M12.094%201v22%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h24v24H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
